export default "/assets/images/mila-room-showcase-02.jpg?6e1495415c31b7eac041438f014505b6";